import React from 'react';
import {
  getAnalyticsConsent,
  setAnalyticsConsent,
} from '../../utils/analyticsConsent';

function CookieConsentBanner() {
  const [consent, setConsent] = React.useState(() => getAnalyticsConsent());
  const [isVisible, setIsVisible] = React.useState(false);
  const [showManage, setShowManage] = React.useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = React.useState(false);

  React.useEffect(() => {
    const currentConsent = getAnalyticsConsent();
    setConsent(currentConsent);
    setAnalyticsEnabled(currentConsent === 'granted');
    const timer = window.setTimeout(() => setIsVisible(true), 30);
    return () => window.clearTimeout(timer);
  }, []);

  if (consent) {
    return null;
  }

  const handleChoice = (value) => {
    setIsVisible(false);
    window.setTimeout(() => {
      setConsent(value);
      setAnalyticsConsent(value);
    }, 220);
  };

  return (
    <aside
      className={`cookie-consent-banner${isVisible ? ' cookie-consent-banner-visible' : ''}`}
      aria-label="Cookie consent"
    >
      <div className="cookie-consent-content">
        <div className="cookie-consent-copy">
          <p className="cookie-consent-title">We use cookies <span aria-hidden="true">🍪</span></p>
          <p className="cookie-consent-text">
            We use cookies to keep Whe2 running smoothly and improve your experience.
            {' '}
            {!showManage ? (
              <a
                className="cookie-consent-inline-link"
                href="/legal/privacy-policy.html"
                target="_blank"
                rel="noreferrer"
              >
                Learn more →
              </a>
            ) : null}
          </p>
        </div>
        <div className="cookie-consent-actions">
          {!showManage ? (
            <>
              <button
                type="button"
                className="cookie-consent-button cookie-consent-button-secondary"
                onClick={() => setShowManage(true)}
              >
                Manage
              </button>
              <button
                type="button"
                className="cookie-consent-button cookie-consent-button-primary"
                onClick={() => handleChoice('granted')}
              >
                Accept
              </button>
            </>
          ) : null}
        </div>
      </div>
      {showManage ? (
        <div className="cookie-consent-manage">
          <p className="cookie-consent-manage-intro">
            Choose which cookies you want to use on Whe2.
          </p>

          <div className="cookie-consent-option-card">
            <div className="cookie-consent-manage-row">
              <div className="cookie-consent-manage-copy">
                <p className="cookie-consent-manage-title">Essential cookies</p>
                <p className="cookie-consent-manage-text">Always on to keep Whe2 running.</p>
              </div>
              <span className="cookie-consent-status">Always on</span>
            </div>
          </div>

          <div className="cookie-consent-option-card">
            <div className="cookie-consent-manage-row cookie-consent-manage-row-toggle">
              <div className="cookie-consent-manage-copy">
                <div className="cookie-consent-manage-title-row">
                  <p className="cookie-consent-manage-title">Analytics cookies</p>
                  <button
                    type="button"
                    className={`cookie-consent-toggle${analyticsEnabled ? ' cookie-consent-toggle-enabled' : ''}`}
                    aria-pressed={analyticsEnabled}
                    onClick={() => setAnalyticsEnabled((current) => !current)}
                  >
                    <span className="cookie-consent-toggle-thumb" />
                  </button>
                </div>
                <p className="cookie-consent-manage-text">Help us improve your experience on Whe2.</p>
              </div>
            </div>
          </div>

          <div className="cookie-consent-manage-actions">
            <button
              type="button"
              className="cookie-consent-button cookie-consent-button-secondary"
              onClick={() => setShowManage(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="cookie-consent-button cookie-consent-button-primary"
              onClick={() => handleChoice(analyticsEnabled ? 'granted' : 'denied')}
            >
              Save preferences
            </button>
          </div>
        </div>
      ) : null}
    </aside>
  );
}

export default CookieConsentBanner;
